<template>
  <Modal
    :isOpened="isOpened"
    :maxWidth="maxWidth"
    @close="$emit('close')"
  >
    <template v-slot>
      <div class="AdverstisingModal d-flex">
        <AdvertisingModalLeft
          class="AdverstisingModal_left"
          :leftButtonUrl="leftButtonUrl"
          :rightButtonUrl="rightButtonUrl"
        />
        <div class="AdverstisingModal_right hidden-sm-and-down">
          <v-img
            max-width="100%"
            contain
            :src="'./assets/backgrounds/AdvertisingModal.png'"
          />
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
  import AdvertisingModalLeft from '@/components/ui/partials/AdvertisingModal/AdvertisingModalLeft'
  import Modal from '@/components/ui/common/Modal/Modal'

  export default {
    components: {
      AdvertisingModalLeft,
      Modal,
    },
    props: {
      isOpened: {
        type: Boolean,
        default: false,
      },
      maxWidth: {
        type: [String, Number,],
        default: 1371,
      },
    },
    data() {
      return {
        leftButtonUrl: 'https://conseil.wesave.fr/',
        rightButtonUrl: 'https://wesave.fr/',
      }
    },
  }
</script>

<style scoped lang="scss">
.AdverstisingModal {
  &_left {
    flex: 1 0 56%;
    padding: 72px;
    background: white;
    overflow: hidden;
  }
  &_right {
    flex: 0 0 44%;
    position: relative;
    background: $color-00c3f1;
    overflow: hidden;
  }
}
</style>
